export default "/images/copy.svg?6d17f9397434e000eee66a696ed4f23a";